import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

/** The bits of a Content Vault item a store link needs. */
export interface StoreLinkContent {
  store_listing_id?: number | null;
}

/** Every "go to the store" link in the app goes through here (the in-app store). */
@Injectable({ providedIn: 'root' })
export class StoreLinkService {
  constructor(private router: Router, private location: Location) {}

  /** Browse the store, pre-filtered by game genre / system labels. */
  openStore(filters: { genre?: string | null; system?: string | null } = {}): void {
    const queryParams: Record<string, string> = {};
    if (filters.genre) queryParams['genre'] = filters.genre;
    if (filters.system) queryParams['system'] = filters.system;
    this.openInternal(['/store'], queryParams);
  }

  /**
   * One item's store page. Returns false when it has none (not for sale), so
   * the caller can say so.
   */
  openContent(content: StoreLinkContent, newTab = true): boolean {
    if (!content.store_listing_id) return false;
    const commands = ['/marketplace/listing', content.store_listing_id];
    newTab ? this.openInternal(commands) : this.router.navigate(commands);
    return true;
  }

  /** Buy an item: its store page. */
  buyContent(content: StoreLinkContent): boolean {
    return this.openContent(content);
  }

  /** Where a buyer downloads what they bought. */
  openDownloads(): void {
    this.openInternal(['/marketplace/orders']);
  }

  /** New tab on an app route; respects a nested base href. */
  private openInternal(commands: unknown[], queryParams?: Record<string, string>): void {
    const url = this.router.serializeUrl(this.router.createUrlTree(commands, { queryParams }));
    window.open(this.location.prepareExternalUrl(url), '_blank');
  }
}
